var _style, _g, _defs, _polygon, _defs2, _defs3, _defs4, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCrono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 549.6 596.8",
    style: {
      enableBackground: "new 0 0 549.6 596.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001489;}\n\t.st1{fill:#EB3300;}\n\t.st2{enable-background:new    ;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#EB3300;}\n\t.st4{clip-path:url(#SVGID_5_);}\n\t.st5{clip-path:url(#SVGID_6_);}\n\t.st6{clip-path:url(#SVGID_8_);fill:#EB3300;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479.6,282.1c43,82.8,49.6,160,9.5,195.2c-56.4,49.4-183.6-3.3-284-117.8S69,112,125.5,62.6 c40.1-35.2,115.8-18.5,192.3,35C206.2,6.9,90.7-26.9,33.6,23.2C-39.1,86.9,10,261.7,143.3,413.7s300.2,223.5,372.8,159.8 C573.3,523.4,554.8,404.5,479.6,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.1,220.9c11,20.3,12.9,39.5,3.1,48.1c-13.5,11.8-43.9-0.8-67.9-28.2s-32.6-59.2-19.1-71 c9.8-8.6,28.6-4.2,47.3,9.4c-35.6-31.8-74.2-44.7-92.6-28.6c-21.9,19.2-7.1,71.8,33,117.6s90.5,67.3,112.3,48.1 C443.7,300.3,435.9,260.4,409.1,220.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "108.5,329.6 109.1,99.3 330.5,227.1 329.8,457.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "330.3,282.6 285.7,201.2 187,244.7 156.5,189 108.5,329.6 262,381.5 231.6,326.1  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "231.3,180.9 184.8,52.1 278.3,68.6 324.7,197.3  "
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_4_",
    points: "212.8,129.7 185.1,52.1 296.7,119.7 324.5,197.3 212.8,129.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_7_",
    points: "212.8,129.7 185.1,52.1 296.7,119.7 324.5,197.3 212.8,129.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "255.2,113.3 264.3,108 185.1,52.1 232.7,126.4 241.8,121.1 303.9,184.8 317.3,177.1  "
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrono);
export default __webpack_public_path__ + "static/media/logo_crono.8308ac441548540789c1b0d715798eb3.svg";
export { ForwardRef as ReactComponent };